
import { Card, CardActions, CardBody, CardTitle } from '@progress/kendo-react-layout'
import { Button } from '@progress/kendo-react-buttons'
import React from 'react'
import { Link } from 'react-router-dom'
import Scrollbars from 'react-custom-scrollbars-2'

export default function ErrorCard(props: ErrorProps) {
    return (
        <Card style={{ margin: '10rem' }}
            type="error"
        >
            <CardBody>
                <CardTitle><b>An unexpected error occurred!</b></CardTitle>
                <CardTitle>{props.message}</CardTitle>

                <Scrollbars autoHeight={true} autoHeightMin={'400px'}>
                    {props.details}
                </Scrollbars>

            </CardBody>
            <CardActions style={{ color: '#000' }}>
                <span className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary">
                    <Link to='/'><Button themeColor='primary' size='large' icon='refresh'>Retry</Button></Link>
                </span>
                <span className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary">
                    <Link to='/signout'> <Button themeColor='secondary' size='large' icon='logout'>Sign out</Button></Link>
                </span>
            </CardActions>
        </Card>
    )
}

export type ErrorProps = {
    message: string
    details: string
}